import React from "react";
import { Helmet } from "react-helmet";

import { VideoShowcase } from "../components/common/VideoShowcase/VideoShowcase";

const Lhangar = () => {
  const videos = [
    "https://www.youtube.com/embed/B3SMoq0pwkM?si=E8zHqLQF4SRAciVM",
    "https://www.youtube.com/embed/Td0u0mJSV8E?si=bH9X83TciWFmRWN8",
    "https://www.youtube.com/embed/rO2SF_reLT0?si=viVEZsLh5Rw8e-s4",
    "https://www.youtube.com/embed/WmptIXY33hM?si=4xETkvkRGwkmrwM1",
  ];

  return (
    <>
      <Helmet>
        <title>LHANGAR — Lembawe9</title>

        <meta
          name="description"
          content="Discover LHANGAR, the Moroccan live rap cypher connecting established artists and emerging talent."
        />
      </Helmet>

      <main>
        <VideoShowcase
          sectionNumber="LHANGAR"
          eyebrow="LIVE CYPHER"
          title="THE STAGE."
          accentTitle="THE MOVEMENT."
          description="Six artists. Two beats. Thirty-two bars each. LHANGAR connects established names and emerging talent while taking Moroccan rap into unique cultural spaces across the country."
          videos={videos}
        />
      </main>
    </>
  );
};

export default Lhangar;